import React, { FC, useEffect } from 'react';
import { StylesProvider } from '@mui/styles';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';

import { defaultThemeSettings, setupTheme, i18nInit } from 'shared/helpers';
import { logger, LogEvents } from 'kioskApp/helpers';
import { Loader } from 'shared/components';
import { PaymentKioskPage } from 'kioskApp/pages';
import { StoreProvider } from 'kioskApp/providers';
import AppSkeleton from 'kioskApp/KioskApp.Skeleton';
import { Store } from 'kioskApp/models/Index';

declare module '@mui/material/Button' {
    interface ButtonPropsVariantOverrides {
        primary: true;
        secondary: true;
    }
}

export const KioskApp: FC = observer(() => {
    useEffect(() => {
        window.addEventListener('error', handleError);

        Store.init()
            .then(() => i18nInit(Store.language))
            .then(() => Store.setReady());
        // eslint-disable-next-line
    }, []);

    const defaultTheme = setupTheme(
        Store.configuration.theme ?? defaultThemeSettings
    );

    const handleError = (event: any) => {
        const { message, error } = event;
        logger.logError(
            'Unhandled client script exception',
            LogEvents.UnhandledScriptError,
            { message, error }
        );
        return true;
    };

    return Store.isReady ? (
        <StoreProvider store={Store}>
            <StylesProvider injectFirst>
                <ThemeProvider theme={defaultTheme}>
                    <BrowserRouter>
                        <Switch>
                            <Route path='/' component={PaymentKioskPage} />
                        </Switch>

                        <Loader loader={Store.loader} />
                    </BrowserRouter>
                </ThemeProvider>
            </StylesProvider>
        </StoreProvider>
    ) : (
        <AppSkeleton />
    );
});
